import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Section from '../components/Section';
import TeacherCards from "./Classes/TeacherCards";




const Teachers = () => {

  return (

    <>

      <Navbar/>

      {/* Meet Our Teachers Section */}
      <Section >
        <TeacherCards/>
      </Section>


      <Footer/>
    
    </>

  );

}

export default Teachers;